import BaseStore from 'customer-flows/stores/base-store'
import { context } from 'customer-flows/utils/core'
import { getPriceMoney, getCandidatesForSlot } from 'customer-flows/utils/dynamic-pricing'

export default class ActivityDynamicPricingStoreClass extends BaseStore {
  @context('tickets:selectableTickets') selectableTickets: TicketsStore['selectableTickets']

  getPricingEntry(priceEntry: AvailabilityTimePrice | undefined): AvailabilityTimePricing | undefined {
    if (!priceEntry?.pricing?.length) return undefined

    return priceEntry.pricing.reduce((lowest, current) =>
      parseFloat(getPriceMoney(current).amount) < parseFloat(getPriceMoney(lowest).amount) ? current : lowest
    )
  }

  getTicketForSlot(slot: AvailabilityTime): Ticket | undefined {
    const candidates = getCandidatesForSlot(slot, this.selectableTickets)
    return candidates[0]
  }

  getDisplayPriceForDate(priceRange: Money[]): Money | null {
    return priceRange[0] ?? null
  }
}

declare global {
  export type ActivityDynamicPricingStore = ActivityDynamicPricingStoreClass
  export interface StoreRegistry {
    'dynamic-pricing/activity': ActivityDynamicPricingStore
  }
}
